export const prepareSaveContent = (): Promise<string> => {
  return new Promise((resolve, reject) => {
    Excel.run(async (context) => {
      Office.context.document.getFileAsync(
        Office.FileType.Compressed,
        { sliceSize: 65536 },
        (result) => {
          if (result.status !== Office.AsyncResultStatus.Succeeded) {
            reject(result.error.message);
            return;
          }

          const myFile = result.value;
          const sliceCount = myFile.sliceCount;
          const docDataSlices: Uint8Array[] = [];
          let slicesReceived = 0;
          let gotAllSlices = true;

          const getSliceAsync = (file: Office.File, nextSlice: number) => {
            file.getSliceAsync(nextSlice, (sliceResult) => {
              if (sliceResult.status === Office.AsyncResultStatus.Succeeded) {
                if (!gotAllSlices) return;

                docDataSlices[sliceResult.value.index] = sliceResult.value.data;
                slicesReceived++;

                if (slicesReceived === sliceCount) {
                  file.closeAsync();

                  const docData = docDataSlices.reduce(
                    (acc, slice) => new Uint8Array([...acc, ...slice]),
                    new Uint8Array()
                  );

                  const base64String = btoa(
                    Array.from(docData).map(code => String.fromCharCode(code)).join('')
                  );

                  resolve(base64String);
                } else {
                  getSliceAsync(file, nextSlice + 1);
                }
              } else {
                gotAllSlices = false;
                file.closeAsync();
                reject(sliceResult.error.message);
              }
            });
          };

          getSliceAsync(myFile, 0);
        }
      );

      await context.sync();
    }).catch(reject);
  });
};
